<template>
  <div class="asc-global-filter-table-item">
    <div class="asc-global-filter-table-item--header">
      <asc-checkbox
        v-model="isChecked"
        :label="tableItem.text"
        :checked="isChecked"
        @change="handleUpdateHeaderData(tableItem.value, isChecked)"
      />
    </div>
    <div class="asc-global-filter-table-item--details">
      <div class="asc-global-filter-table-items--details-header">
        {{ filterText }}: {{ getSelectedText }}
      </div>
      <template v-if="isExpanded && !subGroup">
        <div
          v-for="(item, index) in tableItem.items"
          :key="index"
          class="asc-global-filter-table-items--details-checkbox"
        >
          <asc-checkbox
            v-model="item.checked"
            class="asc-checkbox"
            :label="item.text"
            :checked="item.checked"
            @change="
              handleUpdateItemData(tableItem.value, item.value, item.checked)
            "
          />
        </div>
      </template>
      <template v-if="isExpanded && subGroup">
        <div v-for="(groupItem, groupIndex) in groups">
          <div class="asc-subscription-center-table--headerGroup">
            {{ groupItem.name.toUpperCase() }}
          </div>
          <div
            v-for="(item, index) in getItemsInThisGroup(groupIndex)"
            :key="index"
            class="asc-global-filter-table-items--details-checkbox leftIndented"
          >
            <asc-checkbox
              v-model="item.checked"
              class="asc-checkbox"
              :label="item.text"
              :checked="item.checked"
              @change="
                handleUpdateItemData(tableItem.value, item.value, item.checked)
              "
            />
          </div>
        </div>
      </template>
    </div>
    <div class="asc-global-filter-table-item--expand-collapse">
      <asc-accent-button
        button-text=""
        :on-click="handleExpandCollapse"
        :icon="getExpandCollapseIcon"
        icon-only
        secondary
        size="20"
      ></asc-accent-button>
    </div>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscCheckbox from '@/components/atoms/AscCheckbox'

import { AscSubscriptionCenterTableMixin } from '@/components/mixins'

export default {
  name: 'AscGlobalFilterTableItem',

  components: {
    AscAccentButton,
    AscCheckbox,
  },

  mixins: [AscSubscriptionCenterTableMixin],

  props: {
    tableItem: {
      type: Object,
      default: () => {},
    },
    filterText: {
      type: String,
      default: '',
    },
    groups: {
      type: Array,
      default: () => [],
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
    onExpandCollapse: {
      type: Function,
      default: () => {},
    },
    onUpdateHeaderData: {
      type: Function,
      default: () => {},
    },
    onUpdateItemData: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      isExpanded: false,
      isChecked: false,
    }
  },

  computed: {
    getExpandCollapseIcon() {
      return this.isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
    },

    getSelectedText() {
      const filteredItems = this.tableItem.items
        .filter(item => item.checked)
        .map(item => item.text)
      return filteredItems.join(', ')
    },
  },

  watch: {
    tableItem: {
      immediate: true,
      deep: true,
      handler(newItem) {
        this.tableItem = newItem
        this.isChecked = newItem.checked
        this.isExpanded = newItem.expanded
      },
    },
  },

  methods: {
    getItemsInThisGroup(groupIndex) {
      return this.tableItem.items.filter(itemObj => {
        return itemObj.group === groupIndex
      })
    },
    handleExpandCollapse() {
      this.isExpanded = !this.isExpanded
      if (this.onExpandCollapse) {
        this.onExpandCollapse(this.tableItem.value, this.isExpanded)
      }
    },

    handleUpdateHeaderData(value, checked) {
      const numberCheckedItems = this.tableItem.items.filter(
        item => item.checked,
      ).length

      if (checked && numberCheckedItems === 0) {
        this.tableItem.items = this.tableItem.items.map(item => {
          return {
            ...item,
            checked: true,
          }
        })
      }

      if (!checked && numberCheckedItems > 0) {
        this.tableItem.items = this.tableItem.items.map(item => {
          return {
            ...item,
            checked: false,
          }
        })
      }

      if (this.onUpdateHeaderData) {
        this.onUpdateHeaderData(value, checked)
      }

      // eslint-disable-next-line no-unused-vars
      this.tableItem.items.forEach(item => {
        // this was turned off to help performance for subscription center
        // as far as I can tell it doesn't impact global filter
        // this.handleUpdateItemData(value, item.value, item.checked)
      })
    },

    handleUpdateItemData(parentValue, itemValue, checked) {
      const numberCheckedItems = this.tableItem.items.filter(
        item => item.checked,
      ).length

      this.isChecked = numberCheckedItems > 0
      this.tableItem.checked = this.isChecked

      if (this.onUpdateHeaderData) {
        // this.onUpdateHeaderData(parentValue, this.isChecked)
      }

      if (this.onUpdateItemData) {
        this.onUpdateItemData(parentValue, itemValue, checked)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-global-filter-table-item {
  display: flex;
  border: 1px solid $gray-300;
  padding: 10px 16px;

  // we reuse these table items for subscription center
  // where the width isn't limited so just switch to full width layout
  &.fullWidthLayout {
    .asc-global-filter-table-item--header {
      width: auto;
      flex: 1;

      label {
        max-width: initial;
      }
    }

    .asc-global-filter-table-item--details {
      width: auto;
      flex: 2;

      .asc-subscription-center-table--headerGroup {
        border: none;
        padding: 10px 0;
      }
    }
  }

  &--header {
    width: 180px;
    padding-top: 8px;

    .p-primary {
      margin-top: -2px;
    }

    label {
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &--details {
    width: 440px;
    padding-top: 5px;

    .asc-global-filter-table-items--details-header {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 400px;
      margin-bottom: 8px;
    }

    .asc-global-filter-table-items--details-checkbox {
      margin-bottom: 5px;

      &.leftIndented {
        margin-left: 25px;
      }
    }

    .p-primary {
      margin-top: -2px;
    }

    label {
      max-width: 360px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &--expand-collapse {
    width: 40px;

    .v-btn {
      border: 0 !important;

      .v-icon {
        font-size: 20px !important;
      }
    }
  }
}
</style>
